export enum Role {
  Developer = 'developer',
  Manager = 'Manager',
  Coordinator = 'Coordinador',
  Employee = 'Empleado',
  Client = 'Cliente',
}
